import React from 'react';
import type { Issue } from '../../types/issue';
import { causeConsultation, type ObservationCounts } from '../../utils/stageWork';

export const CauseConsultationCard: React.FC<{
  issue: Issue;
  counts: Pick<ObservationCounts, 'strata' | 'gemba'>;
  onDescribe: () => void;
  onBeginObservation?: () => void;
  onBeginCause?: () => void;
}> = ({ issue, counts, onDescribe, onBeginObservation, onBeginCause }) => {
  const consult = causeConsultation(issue, counts);
  return (
    <section className="max-w-xl rounded-md border border-slate-200 px-3 py-2.5 dark:border-slate-800">
      <h3 className="text-[13px] font-semibold text-slate-950 dark:text-slate-50">Análise de causa</h3>
      <p className="mt-2 text-[11px] font-semibold tracking-wide text-slate-400">Pré-requisitos</p>
      <ul className="mt-1 space-y-1 text-[13px] text-slate-700 dark:text-slate-200">
        {consult.items.map((item) => (
          <li key={item.label}>
            <span className={item.done ? 'text-emerald-700' : 'text-slate-400'}>{item.done ? '✓' : '○'}</span>
            {' '}
            {item.label}
            {item.detail ? <span className="text-slate-500"> {item.detail}</span> : null}
          </li>
        ))}
      </ul>
      {consult.note ? <p className="mt-2 text-[13px] text-slate-600 dark:text-slate-300">{consult.note}</p> : null}
      <div className="mt-2">
        {consult.action === 'describe' ? (
          <button type="button" onClick={onDescribe} className="rounded bg-blue-600 px-3 py-1.5 text-[12px] font-semibold text-white hover:bg-blue-700">
            Descrever fenômeno
          </button>
        ) : null}
        {consult.action === 'begin-observation' && onBeginObservation ? (
          <button type="button" onClick={onBeginObservation} className="rounded bg-blue-600 px-3 py-1.5 text-[12px] font-semibold text-white hover:bg-blue-700">
            Iniciar observação
          </button>
        ) : null}
        {consult.action === 'begin-cause' && onBeginCause ? (
          <button type="button" onClick={onBeginCause} className="rounded bg-blue-600 px-3 py-1.5 text-[12px] font-semibold text-white hover:bg-blue-700">
            Iniciar análise de causa
          </button>
        ) : null}
      </div>
    </section>
  );
};
